/*
 * Copyright (C) 2023 Nethesis S.r.l.
 * SPDX-License-Identifier: GPL-3.0-or-later
 */

import {
  X,
  ArrowRight,
  Bell,
  User,
  Search,
  Expand,
  Minimize2,
  RotateCcw,
  Download,
  ExternalLink,
  TrendingUp,
  Settings,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  Info,
  Package,
  Plus,
  Rocket,
  Cpu,
  Save,
  Copy,
  Server,
  Box,
  Link,
  Edit,
  Key,
  Star,
  Check,
  ZoomIn,
  Calendar,
  AlertTriangle,
  Wrench,
  Network,
  Database,
  HardDrive,
  ArrowDown,
  Clock,
  Hourglass,
  CheckCircle,
  CircleX,
  Power,
  FileText,
  MoreVertical,
  RotateCw,
  Trash2,
  Eraser,
  Rows,
  Columns,
  Library,
  Users,
  Router,
  Shield,
  ServerCog,
  ShieldCheck,
  BookOpen,
  AtSign,
  User as UserIcon,
  HelpCircle,
  Mail,
  Lock,
  Folder,
  Asterisk,

  UserCheck,
  Ruler,
  Filter,
  XCircle,
  Award,
  FolderOpen,
  Inbox,
  CloudUpload
} from "lucide-vue-next";

export const useIconService = () => {
  return {
    Close20: X,
    ArrowRight20: ArrowRight,
    ArrowRight32: ArrowRight,
    Notification20: Bell,
    UserAvatar20: User,
    UserAvatar32: User,
    Search20: Search,
    RowExpand20: Expand,
    RowCollapse20: Minimize2,
    Reset20: RotateCcw,
    Reset32: RotateCcw,
    Download20: Download,
    Launch20: ExternalLink,
    Upgrade20: TrendingUp,
    Upgrade32: TrendingUp,
    Settings16: Settings,
    Settings20: Settings,
    Settings32: Settings,
    ChevronDown20: ChevronDown,
    ChevronUp20: ChevronUp,
    ChevronLeft20: ChevronLeft,
    ChevronRight20: ChevronRight,
    Information16: Info,
    Information20: Info,
    InformationFilled16: Info,
    Application20: Package,
    Application32: Package,
    Add20: Plus,
    Rocket20: Rocket,
    Rocket32: Rocket,
    Chip20: Cpu,
    Chip32: Cpu,
    Save20: Save,
    Save32: Save,
    Copy20: Copy,
    EdgeNode20: Server,
    EdgeNode32: Server,
    Cube32: Box,
    EdgeCluster20: Box,
    EdgeCluster32: Box,
    Connect32: Link,
    Connect20: Link,
    Edit20: Edit,
    Password20: Key,
    Star20: Star,
    Checkmark20: Check,
    ZoomIn20: ZoomIn,
    Events32: Calendar,
    Events20: Calendar,
    Events16: Calendar,
    Link20: Link,
    Link32: Link,
    WarningAlt20: AlertTriangle,
    WarningAlt32: AlertTriangle,
    Tools20: Wrench,
    Tools32: Wrench,
    Network_220: Network,
    Network_232: Network,
    DataBase20: Database,
    DataBase32: Database,
    DataBackup20: HardDrive,
    DataBackup32: HardDrive,
    ArrowDown20: ArrowDown,
    ArrowDown32: ArrowDown,
    Time20: Clock,
    Time32: Clock,
    Hourglass20: Hourglass,
    Hourglass32: Hourglass,
    CheckmarkFilled16: CheckCircle,
    CheckmarkFilled20: CheckCircle,
    CheckmarkFilled32: CheckCircle,
    ErrorFilled16: CircleX,
    ErrorFilled20: CircleX,
    ErrorFilled32: CircleX,
    Warning16: AlertTriangle,
    Warning20: AlertTriangle,
    Warning32: AlertTriangle,
    Power16: Power,
    Power20: Power,
    Power32: Power,
    Document20: FileText,
    Document32: FileText,
    OverflowMenuVertical20: MoreVertical,
    OverflowMenuVertical32: MoreVertical,
    Restart20: RotateCw,
    Restart32: RotateCw,
    TrashCan20: Trash2,
    TrashCan32: Trash2,
    Erase20: Eraser,
    Erase32: Eraser,
    Row20: Rows,
    Column20: Columns,
    Catalog20: Library,
    Catalog32: Library,
    Group20: Users,
    Router32: Router,
    Router20: Router,
    Certificate32: ShieldCheck,
    Certificate20: ShieldCheck,
    BareMetalServer20: ServerCog,
    BareMetalServer32: ServerCog,
    Firewall20: Shield,
    Firewall32: Shield,
    Wikis32: BookOpen,
    Wikis20: BookOpen,
    Wikis16: BookOpen,
    At32: AtSign,
    At20: AtSign,
    User16: UserIcon,
    User20: UserIcon,
    User32: UserIcon,
    Unknown16: HelpCircle,
    Unknown20: HelpCircle,
    Unknown32: HelpCircle,
    Email16: Mail,
    Email20: Mail,
    Email32: Mail,
    Locked16: Lock,
    Locked20: Lock,
    Locked32: Lock,
    Folder16: Folder,
    Folder20: Folder,
    Folder32: Folder,
    Asterisk16: Asterisk,
    Asterisk20: Asterisk,
    Asterisk32: Asterisk,
    Box16: Box,
    Box20: Box,
    Box32: Box,
    UserMilitary32: UserCheck,
    Rule16: Ruler,
    Rule20: Ruler,
    Rule32: Ruler,
    Filter16: Filter,
    Filter20: Filter,
    Filter32: Filter,
    CloseFilled16: XCircle,
    CloseFilled20: XCircle,
    CloseFilled32: XCircle,
    Badge16: Award,
    Badge20: Award,
    Badge32: Award,
    FolderShared16: FolderOpen,
    FolderShared20: FolderOpen,
    FolderShared32: FolderOpen,
    MailAll16: Inbox,
    MailAll20: Inbox,
    MailAll32: Inbox,
    CloudUpload16: CloudUpload,
    CloudUpload20: CloudUpload,
    CloudUpload32: CloudUpload,
  };
};
